/**
 *
 *
 * @export
 * @class HrefResolverService
 */
var HrefResolverService = /** @class */ (function () {
    /**
     * Creates an instance of HrefResolverService.
     * @param {ConsoleService} console
     * @memberof HrefResolverService
     */
    function HrefResolverService(console) {
        this.console = console;
        this.urlMap = new Map();
        // temporary hack - to bypass url resolver error in npm start mode
        if (window.location.href === 'http://localhost:4200/') {
            this.urlMap.set('screenerDefault', 'http://localhost:1776/fund-buyer-portal/en-ch/products/product-list');
            this.urlMap.set('mySubscriptions', 'http://localhost:1776/fund-buyer-portal/en-ch/services/gls/subscription/gls-subscription.jsn');
        }
    }
    /**
     * Given a URL Map, sets the URL Map.
     *
     * @param {*} jsonUrlMap
     * @memberof HrefResolverService
     */
    HrefResolverService.prototype.setUrlMap = function (jsonUrlMap) {
        this.console.log('Setting url map : ' + JSON.stringify(jsonUrlMap));
        for (var _i = 0, _a = Object.keys(jsonUrlMap); _i < _a.length; _i++) {
            var namedUrl = _a[_i];
            this.urlMap.set(namedUrl, jsonUrlMap[namedUrl]);
            this.console.log(JSON.stringify(namedUrl) + ' ' + JSON.stringify(jsonUrlMap[namedUrl]));
        }
    };
    /**
     * Retrieves the requested hrefValue associated with the hrefKey
     *
     * @param {string} hrefKey
     * @return {string}
     * @memberof HrefResolverService
     */
    HrefResolverService.prototype.getResolvedUrl = function (hrefKey) {
        this.console.log('Got href value: ' + hrefKey);
        var resolvedUrl = this.urlMap.get(hrefKey);
        this.console.log('Resolved: ' + resolvedUrl + ' using key: ' + hrefKey);
        if (resolvedUrl === undefined) {
            throw new Error('Could not resolve a urlMap value for key: ' + hrefKey);
        }
        return resolvedUrl;
    };
    return HrefResolverService;
}());
export { HrefResolverService };
//# sourceMappingURL=href-resolver.js.map